export enum AcceptType {
  PDF = '.pdf',
  IMAGE = '.jpg,.png,.jpeg,.gif,.webp',
  SVG = '.svg',
}
